export const QrCode = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="10" height="10" stroke="currentColor" stroke-width="2"/>
<rect x="3" y="19" width="10" height="10" stroke="currentColor" stroke-width="2"/>
<rect x="19" y="3" width="10" height="10" stroke="currentColor" stroke-width="2"/>
<rect x="6.5" y="6.5" width="3" height="3" fill="currentColor" stroke="currentColor"/>
<rect x="6.5" y="22.5" width="3" height="3" fill="currentColor" stroke="currentColor"/>
<rect x="27.5" y="22.5" width="3" height="1" transform="rotate(90 27.5 22.5)" fill="currentColor" stroke="currentColor"/>
<rect x="29.5" y="26.5" width="3" height="1" transform="rotate(90 29.5 26.5)" fill="currentColor" stroke="currentColor"/>
<rect x="22.5" y="6.5" width="3" height="3" fill="currentColor" stroke="currentColor"/>
<path d="M26 19H29V22" stroke="currentColor" stroke-width="2"/>
<path d="M29 26L29 29L26 29" stroke="currentColor" stroke-width="2"/>
<path d="M22 29L19 29L19 26" stroke="currentColor" stroke-width="2"/>
<path d="M18 19H22" stroke="currentColor" stroke-width="2"/>
<path d="M23 20V25H20" stroke="currentColor" stroke-width="2"/>
<path d="M27 22V26" stroke="currentColor" stroke-width="2"/>
<path d="M25 26V28" stroke="currentColor" stroke-width="2"/>
<path d="M19 22V24" stroke="currentColor" stroke-width="2"/>
</svg>`;
